import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CreateOutlinedIcon from '@mui/icons-material/CreateOutlined';
import UploadFileOutlinedIcon from '@mui/icons-material/UploadFileOutlined';
import { PageHeader } from '@/components/shared';
import * as S from './FinanceXOnboarding.styles';

type Props = {
  onConnectBank: () => void;
  onImportCSV: () => void;
  onSkip: () => void;
  isConnecting: boolean;
};

const FinanceXOnboardingComponent = function ({
  onConnectBank,
  onImportCSV,
  onSkip,
  isConnecting,
}: Props): JSX.Element {
  return (
    <S.Wrapper>
      <PageHeader title="Welcome to FinanceX" />

      <S.Intro>
        Track your company's spending, revenue, vendors, and subscriptions in one place.
        Get started by connecting your bank account or importing your transaction history.
      </S.Intro>

      <S.OptionGrid>
        <S.OptionCard $variant="primary" onClick={onConnectBank} disabled={isConnecting}>
          <S.IconCircle $variant="primary">
            <AccountBalanceOutlinedIcon sx={{ fontSize: 22 }} />
          </S.IconCircle>
          <S.OptionInfo>
            <S.OptionTitle>
              {isConnecting ? 'Connecting...' : 'Connect Your Bank'}
            </S.OptionTitle>
            <S.OptionDesc>
              Securely link your bank accounts via Plaid. Transactions are imported automatically
              and categorized by AI.
            </S.OptionDesc>
          </S.OptionInfo>
          <S.Badge>Recommended</S.Badge>
        </S.OptionCard>

        <S.Divider>
          <S.DividerText>or</S.DividerText>
        </S.Divider>

        <S.OptionCard $variant="secondary" onClick={onImportCSV}>
          <S.IconCircle $variant="secondary">
            <UploadFileOutlinedIcon sx={{ fontSize: 22 }} />
          </S.IconCircle>
          <S.OptionInfo>
            <S.OptionTitle>Import a CSV</S.OptionTitle>
            <S.OptionDesc>
              Upload a bank statement or accounting export. We'll map the columns and
              categorize each transaction.
            </S.OptionDesc>
          </S.OptionInfo>
          <ArrowForwardIcon sx={{ fontSize: 18, color: '#71717A', flexShrink: 0, mt: 0.5 }} />
        </S.OptionCard>

        <S.OptionCard $variant="tertiary" onClick={onSkip}>
          <S.IconCircle $variant="tertiary">
            <CreateOutlinedIcon sx={{ fontSize: 22 }} />
          </S.IconCircle>
          <S.OptionInfo>
            <S.OptionTitle>Start from Scratch</S.OptionTitle>
            <S.OptionDesc>
              Skip setup and add transactions, vendors, and invoices manually as you go.
            </S.OptionDesc>
          </S.OptionInfo>
          <ArrowForwardIcon sx={{ fontSize: 18, color: '#71717A', flexShrink: 0, mt: 0.5 }} />
        </S.OptionCard>
      </S.OptionGrid>
    </S.Wrapper>
  );
};

export default FinanceXOnboardingComponent;
